import styles from "./table.module.css";
import { useState, useEffect } from "react";
import { ContentCard, Row, Tag } from "@narmi/design_system";
import { Payment } from "./PaymentTable";
import { Case } from "./CaseTable";
import { CASE_TYPES } from "./codesets";

function RelatedCaseRow({ caseobj }: { caseobj: Case }) {
  return (
    <div className="padding--top--s">
      <ContentCard
        kind="button"
        paddingSize="s"
        onClick={() => window.open(`/fednow/cases/${caseobj.case_identification}`, "_blank")}
      >
        <Row gapSize="m">
          <Row.Item>
            <p
              className="padding--bottom--xs fontWeight--semibold whiteSpace--truncate"
              style={{ maxWidth: "100%" }}
            >
              {caseobj.case_identification}
            </p>
          </Row.Item>
          <Row.Item shrink>
            <div className="padding--bottom--xs" style={{ textTransform: "capitalize" }}>
              <Tag label={caseobj.status}></Tag>
            </div>
          </Row.Item>
        </Row>
        <Row>
          <Row.Item>
            <p>{CASE_TYPES[caseobj.kind]}</p>
          </Row.Item>
        </Row>
      </ContentCard>
    </div>
  );
}

export default function RelatedCases({
  payment,
  setRelatedCase,
}: {
  payment: Payment;
  setRelatedCase: CallableFunction;
}) {
  const [relatedCases, setRelatedCases]: [Array<Case>, CallableFunction] = useState([]);

  async function fetchRelatedCases() {
    const paymentsRes = await fetch(
      `/v1/fednow/payments/${payment.payment_identification}/related_payments`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!paymentsRes.ok) {
      return;
    }
    const payments = await paymentsRes.json();
    const paymentIds = payments["results"].map((p: Payment) => p.payment_identification);
    paymentIds.push(payment.payment_identification);
    // check any related payments for cases as well
    let cases = await Promise.all(
      paymentIds.map(async (id: string) => {
        const caseRes = await fetch(`/v1/fednow/payments/${id}/related_cases`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!caseRes.ok) {
          return;
        }
        const caseobjs = await caseRes.json();
        return caseobjs["results"];
      })
    );
    cases = cases.flat();
    setRelatedCase(cases[0]);
    setRelatedCases(cases);
  }
  useEffect(() => {
    fetchRelatedCases();
  }, [payment]);

  if (relatedCases.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.transactionDetailContainer} margin--y padding--all`}>
      <h4 className="fontFamily--body">Related cases</h4>
      {relatedCases.map((c: Case) => (
        <RelatedCaseRow caseobj={c} />
      ))}
    </div>
  );
}
